// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b9490499","239":"dc683736","453":"ae76a5a1","732":"35175cdb"}[chunkId] + ".chunk.js";
};